import loadable from '@loadable/component';

import * as constants from './constants';

export { collectionInfoLookup } from './utils';
export { constants };

const CollectionsBucket = loadable(() => import('./CollectionsBucket'));

export { CollectionsBucket };
